export function getUnits(options) {
  switch (options.fluid) {
    case 'oil':
      return options.units === 'metric' ? 'm3' : 'bbl';
    case 'gas':
      return options.units === 'metric' ? 'E3m3' : 'mcf';
    case 'condensate':
      return options.units === 'metric' ? 'm3' : 'bbl';
    case 'water':
      return options.units === 'metric' ? 'm3' : 'bbl';
    default:
      return '';
  };
};
